/* eslint-disable @typescript-eslint/ban-ts-ignore */
import { VueConstructor } from "vue";
import Router, { RawLocation, Route } from "vue-router";
import { Store } from "vuex";
import { ACTION_TYPES, MUTATION_TYPES } from "@/store/const";
import { StateRoot } from "@/store/state";
import { getLoginData } from "@/lib/authHelper";
import HistoryManager from "@/lib/historyManager";
import { allowAccess as allowAccessHelper } from "@/lib/loginHelpers";
import { setReferral } from "@/lib/referralHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";

export default {
  install(Vue: VueConstructor, { router, store }: { router: Router; store: Store<StateRoot> }) {
    const origReplace = router.replace;
    // @ts-ignore
    router.replace = function(...args) {
      HistoryManager.setReplace();
      // @ts-ignore
      return origReplace.call(this, ...args);
    };
    router.beforeEach(async (to, from, next) => {
      if (to.query.redirectPath) {
        store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, to.query.redirectPath);
      }
      if (to.query.referral) {
        let referral = to.query.referral;
        const referralId = Array.isArray(referral)
          ? referral.find<string>((i): i is string => typeof i === "string") || ""
          : referral;
        setReferral(referralId);
        store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, getProfileUrl(referralId));
      }
      let location: RawLocation | false | void;
      const loginPath = (route: Route) => !!route.meta?.login || route.name === "logout" || route.path === "/";
      if (!store.state.user && getLoginData()) {
        await store.dispatch(ACTION_TYPES.LOGIN, getLoginData());
      }
      const allowAccess = allowAccessHelper(store.state.user);
      const socialLogin = store.state.socialLogin;
      const loggedIn = !!store.state.user;
      const redirectPath = store.state.redirectPath;
      if (to.name === "loginToken") {
        next();
      } else if (to.matched.some(route => route.meta.private && !loggedIn)) {
        location = { name: "login" };
      } else if (to.name === "logout") {
        await store.dispatch(ACTION_TYPES.LOGOUT);
        location = { name: "login" };
      } else if (loginPath(to) && loggedIn && allowAccess) {
        location = { name: "home" };
      } else if (to.name !== "signupEmailConfirm" && loggedIn && !allowAccess && socialLogin) {
        location = { name: "signupEmailConfirm" };
      } else if (to.name !== "signupConfirm" && loggedIn && !allowAccess && !socialLogin) {
        location = { name: "signupConfirm" };
      } else if (loginPath(from) && !loginPath(to) && loggedIn && allowAccess && redirectPath) {
        location = redirectPath;
      }

      if (!loginPath(to) && location && !redirectPath) {
        store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, to);
      } else if (location === redirectPath) {
        store.commit(MUTATION_TYPES.SET_REDIRECT_PATH, null);
      }
      next(location);
    });
    router.afterEach(HistoryManager.afterEachGuard.bind(HistoryManager));
  },
};
